import {showRfqForm} from './product-rfq'
import {showEmailForm} from './product-email'

export default class ProductCallToActions {

  constructor() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (parseInt(urlParams.get('showrfq')) === 1) {
      showRfqForm()
    }
    if (parseInt(urlParams.get('showemail')) === 1) {
      showEmailForm()
    }

    $('.product-ctas .rfq, .product-ctas-desktop .rfq').on("click", () => {
      showRfqForm()
    })

    $('.product-ctas .email,  .product-ctas-desktop .email').on("click", () => {
      showEmailForm()
    })
  }
}